import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { DividerModule } from 'primeng/divider';
import { CommonModule } from '@angular/common';
import { MenuModule } from 'primeng/menu';

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, DividerModule, MenuModule],
  exports: [HeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderModule {}
